import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';


import Countdown from 'components/Countdown';
import Counter from 'components/Counter';
import classNames from 'classnames';

import dataNo from './languages/no-data.json';
import dataNn from './languages/nn-data.json';
import dataNoNorming from './languages/no-data-norming.json';
import dataNnNorming from './languages/nn-data-norming.json';
const dataObj = {
	no: dataNo,
	nn: dataNn,
};

const normingDataObj = {
	no: dataNoNorming,
	nn: dataNnNorming,
};

const INPUT_PAD = 2; // How many to show before and after
const INPUT_HEIGHT = 93; // inkl margin

class Test extends React.Component {
	constructor(props) {
		super(props);
		const grade = Number(this.props.candidateGrade);
		this.data = this.props.isNorming ? normingDataObj[strings.getLanguage()] : dataObj[strings.getLanguage()];
		this.text = this.props.isNorming ? this.data[grade].value : this.data[0].value;
		this.writeFollowingSentence = this.props.isNorming ? strings.writeFollowingSentenceNorming:strings.writeFollowingSentence;
		this.inputRefs = {};

		const inputs = [
			{
				isPlaceholder: true,
				visiblePlacement: 1,
				value: '',
			},
			{
				isPlaceholder: true,
				visiblePlacement: 2,
				value: '',
			},
			{
				visiblePlacement: 3,
				value: '',
			},
		];

		this.state = {
			count: 0,
			currentInputIndex: 2,
			inputs,
			isComplete: false,
			
		};

		this.centerViewportAround = this.centerViewportAround.bind(this);
		this.addPlaceholderInputs = this.addPlaceholderInputs.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.incrementCurrentInputIndex =
			this.incrementCurrentInputIndex.bind(this);
	}

	componentDidMount() {
		const {currentInputIndex} = this.state;

		this.addPlaceholderInputs(currentInputIndex);
		this.centerViewportAround(currentInputIndex);
		

	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.isComplete !== this.state.isComplete &&
			this.state.isComplete
		) {
			if (this.submitButton) {
				this.submitButton.focus();
			}
		}
	}


	updateInput(index, value) {
		const {inputs} = this.state;

		const currentValue = inputs[index].value;
		const valueLengthDiff = Math.abs(currentValue.length - value.length);

		if (valueLengthDiff > 1) {
			return;
		}

		inputs[index].value = value;

		this.setState({
			inputs,
		});
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.incrementCurrentInputIndex();
	}

	incrementCurrentInputIndex() {
		const {currentInputIndex} = this.state;

		const newIndex = currentInputIndex + 1;

		this.addPlaceholderInputs(newIndex);
		this.centerViewportAround(newIndex);
	}

	addPlaceholderInputs(index) {
		const {inputs} = this.state;

		if (inputs.length === index + 1) {
			inputs.push({
				value: '',
			});
			inputs.push({
				value: '',
			});
		} else if (inputs.length === index + 2) {
			inputs.push({
				value: '',
			});
		}

		const count = inputs.filter((input) => input.value.length).length;

		this.setState({
			count,
			currentInputIndex: index,
		});
	}

	centerViewportAround(index) {
		const {inputs} = this.state;

		const newInputs = inputs.slice();

		for (let i = 0; i < newInputs.length; i++) {
			const input = newInputs[i];
			if (index === i - 2) {
				input.visiblePlacement = 5;
			} else if (index === i - 1) {
				input.visiblePlacement = 4;
			} else if (index === i) {
				input.visiblePlacement = 3;
			} else if (index === i + 1) {
				input.visiblePlacement = 2;
			} else if (index === i + 2) {
				input.visiblePlacement = 1;
			} else {
				input.visiblePlacement = 0;
			}
		}

		this.setState(
			{
				inputs: newInputs,
			},
			() => {
				this.inputRefs[index].focus();
			}
		);
	}

	render() {
		const {onNextStep} = this.props;

		const {count, currentInputIndex, inputs, isComplete} =
			this.state;

		return (
			<div>
				<p>{this.writeFollowingSentence}</p>
				<h3 className="text">
					<strong>{this.text}</strong>
				</h3>
				
				<div className="lit-infobar">
					<Countdown
						duration={120}
						onComplete={() => {
							this.setState({
								isComplete: true,
							});
						}}
					/>
					<Counter count={count} />

					
				</div>
			        <div
			          className={classNames('lit-test', 'viewport', 'lit-revealable', {
			            'norming-tight': this.props.isNorming,
			          })}
			          style={{
			            height: (1 + INPUT_PAD * 2) * INPUT_HEIGHT + 'px',
			          }}
			        >
					<div
						className={classNames({
							inputs: true,
							completed: isComplete,
						})}
						           style={{
					             transform:
					               'translateY(-' +
					               (
					                 (currentInputIndex - INPUT_PAD) * INPUT_HEIGHT +
					                 (this.props.isNorming ? INPUT_HEIGHT : 0) // pull up by 1 row for norming
					               ) +
					               'px)',
					           }}
					>
						<form onSubmit={this.handleFormSubmit}>
							{inputs.map((input, i) => {
								return (
									<div
								    className={classNames({
								      'lit-input lit-revealed': true,
								      ['lit-input--' + input.visiblePlacement]: true,
								      placeholder: input.isPlaceholder,
								      'has-value': Boolean(input.value), // <— NEW
								    })}
										key={i}
									>
										<input
											className={classNames({
												'lit-input__field': true,
												disabled:
													input.visiblePlacement < 3,
											})}
											disabled={isComplete}
											onChange={(ev) => {
												const value = ev.target.value;

												this.updateInput(i, value);
											}}
											onFocus={() => {
												this.addPlaceholderInputs(i);
												this.centerViewportAround(i);
											}}
											placeholder={
												input.visiblePlacement === 3
													? strings.writeHere
													: ''
											}
											ref={(ref) => {
												this.inputRefs[i] = ref;
											}}
											spellCheck={false}
											autoComplete="off"
											autoCorrect="off"
											autoCapitalize="off"
											type="text"
											value={input.value}
										/>
									</div>
								);
							})}
							<input
								style={{visibility: 'hidden'}}
								type="submit"
							/>
						</form>
					</div>
				</div>
				{isComplete && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							const results = inputs
								.filter((input) => input.value)
								.map((input) => input.value);
							onNextStep(results);
						}}
						ref={(ref) => {
							this.submitButton = ref;
						}}
					>
						{strings.next}
					</button>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

export default connect(mapStateToProps)(Test);
